<div [ngClass]="showBg?'show-bg':''"
     class="main-container relative flex min-h-screen items-center justify-center px-6 py-10 sm:px-16">

    <div
            class="relative w-full max-w-[870px] rounded-md  p-2"
    >
        <div class="relative flex flex-col justify-center rounded-md bg-bg_primary opacity-90 px-6 py-20 backdrop-blur-lg lg:min-h-[500px]">
            <div class="mx-auto w-full max-w-[440px]">
                <div class="mb-10">
                    <h1 class="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl">{{ 'signin'| translate }}</h1>
                    <p class="text-base font-bold leading-normal text-white-dark">
                        {{ 'enter_your_email_and_password_to_login'| translate }}</p>
                </div>
                <div class="space-y-5 text-normal">
                    <div class="flex flex-col gap-2">
                        <label class="" for="Email">{{ 'email' | translate }}</label>
                        <div class="relative text-normal">
                            <div class="relative">
                                <input [formControl]="loginForm.controls['email']"
                                       class="form-input w-full rounded-md border text-normal  px-4 py-2 text-sm font-semibold  !outline-none  focus:ring-transparent border-[#17263c] bg-input focus:border-primary ps-10 placeholder:text-normal"
                                       id="Email"
                                       [placeholder]="'enter_email' | translate"
                                       type="email"/>
                                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                    <icon-mail [fill]="true"/>
                                </span>
                            </div>

                            <app-validation-error [control]="loginForm.controls['email']"></app-validation-error>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2">
                        <div class="relative text-normal">
                            <div class="flex flex-col gap-2">
                                <label class="" for="Email">{{ 'password' | translate }}</label>
                                <div class="relative text-normal">
                                    <div class="relative">
                                        <app-input-password [formControlItem]="loginForm.controls['password']"
                                                            [placeholder]="'password'| translate"
                                                            [type]="'password'"
                                        >
                                        </app-input-password>
                                        <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                            <icon-lock-dots [fill]="true"/>
                                        </span>
                                    </div>

                                </div>
                                <a (click)='forgotPassword()'
                                   class="cursor-pointer text-primary underline transition hover:text-normal">
                                    {{ 'forgot_password'| translate }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <button (click)="onSubmit()"
                            class="btn btn-gradient !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)] px-3 rounded-md py-2"
                            type="button">
                        {{ 'signin'| translate }}
                    </button>
                </div>
                <div class="text-center text-normal mt-5">
                    {{ 'Dont_have_account'| translate }}
                    <a (click)='changeModalTub()'
                       class="cursor-pointer uppercase text-primary underline transition hover:text-normal">
                        {{ 'signup'| translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>

</div>
